import { Box, Button } from "@mui/material";
import {
  TitleProps,
  useLink,
  useRouterContext,
  useRouterType,
} from "@refinedev/core";
import { AgriErpLogo } from "components/icons/CheckIcon";
import React from "react";

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  const routerType = useRouterType();
  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();

  const ActiveLink = routerType === "legacy" ? LegacyLink : Link;

  return (
    <Button fullWidth variant="text" disableRipple>
      <ActiveLink to="/" style={{ textDecration: "none" }}>
        {collapsed ? (
          <AgriErpLogo
            sx={{ color: "#f7f7f7" }}
            fontSize="large"
            fill="#f7f7f7"
            viewBox="0 0 500 500"
          />
        ) : (
          <Box
            sx={
              {
                // width: "5rem",
                // height: "5rem",
              }
            }
          >
            <AgriErpLogo
              sx={{ color: "#f7f7f7", fontSize: "5.1875rem" }}
              fill="#f7f7f7"
              viewBox="0 0 500 500"
            />
          </Box>
        )}
      </ActiveLink>
    </Button>
  );
};
